import React from "react";
import {withTranslation} from "react-i18next";
import stylesWelcome from "../SchedaSpecialeMIB.module.css"
import Utils from "../../../../../../../utils/Utils";
import Input from "../../../../../../../components/textbox/Input";
import RadioButton from "../../../../../../../components/radiobutton/RadioButton";
import CheckBox from "../../../../../../../components/checkbox/CheckBox";
import styles from "../../../../DatiSpecifici/DatiSpecifici.module.css";


class AgenteCausanteMIB extends React.Component {

    state = {
        agente: {
            liquorAgente1: this.props.statePadre && this.props.statePadre.liquorAgente1 ? this.props.statePadre.liquorAgente1 : false,
            colturaAgente1: this.props.statePadre && this.props.statePadre.colturaAgente1 ? this.props.statePadre.colturaAgente1 : false,
            ricercaAgente1: this.props.statePadre && this.props.statePadre.ricercaAgente1 ? this.props.statePadre.ricercaAgente1 : false,
            pcrAgente1: this.props.statePadre && this.props.statePadre.pcrAgente1 ? this.props.statePadre.pcrAgente1 : false,
            tipizzazione: this.props.statePadre && this.props.statePadre.tipizzazione ? this.props.statePadre.tipizzazione : "",
            tipizzazioneTesto: this.props.statePadre && this.props.statePadre.tipizzazioneTesto ? this.props.statePadre.tipizzazioneTesto : "",
            laboratorio: this.props.statePadre && this.props.statePadre.laboratorio ? this.props.statePadre.laboratorio : "",
            laboratorioTesto: this.props.statePadre && this.props.statePadre.laboratorioTesto ? this.props.statePadre.laboratorioTesto : "",
            corretto: []
        },
        meningite: "",
        malattiaBatterica: "",
        id: "",
        rowList: [],
        row: 0
    }

    constructor(props) {
        super(props)

        this.riceviValore = this.riceviValore.bind(this);
        this.createOggettoBE = this.createOggettoBE.bind(this);
        this.controlloDati = this.controlloDati.bind(this);
        this.controlloCheck = this.controlloCheck.bind(this);
        this.boxCheckbox = this.boxCheckbox.bind(this);

    }

    componentDidMount() {

        let agenteCausanteMIB = this.state.agente

        let statePadre = JSON.parse(JSON.stringify(this.props.statePadre))
        delete statePadre["corretto"];

        if(Utils.isEmpty(statePadre)) {
            if (!this.props.malattiaBatterica) {
                agenteCausanteMIB.corretto = true
            } else {

                if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.agenteMIB) {
                    let agente = this.state.agente
                    let agenteProps = this.props.segnalazioneCopia.schedaSpeciale.agenteMIB

                    agente.liquorAgente1 = agenteProps.liquorAgente1 ? agenteProps.liquorAgente1 : this.state.agente.liquorAgente1
                    agente.colturaAgente1 = agenteProps.colturaAgente1 ? agenteProps.colturaAgente1 : this.state.agente.colturaAgente1
                    agente.ricercaAgente1 = agenteProps.ricercaAgente1 ? agenteProps.ricercaAgente1 : this.state.agente.ricercaAgente1
                    agente.pcrAgente1 = agenteProps.pcrAgente1 ? agenteProps.pcrAgente1 : this.state.agente.pcrAgente1
                    agente.tipizzazione = agenteProps.tipizzazione ? agenteProps.tipizzazione : this.state.agente.tipizzazione
                    agente.tipizzazioneTesto = agenteProps.tipizzazioneTesto ? agenteProps.tipizzazioneTesto : this.state.agente.tipizzazioneTesto
                    agente.laboratorio = agenteProps.laboratorio ? agenteProps.laboratorio : this.state.agente.laboratorio
                    agente.laboratorioTesto = agenteProps.laboratorioTesto ? agenteProps.laboratorioTesto : this.state.agente.laboratorioTesto

                }

            }

        this.setState({agente: agenteCausanteMIB, malattiaBatterica: this.props.malattiaBatterica});
        }
        this.controlloDati()
        let oggetto = this.createOggettoBE()
        this.props.setAgenteMIB(this.state.agente, oggetto)

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.malattiaBatterica != this.props.malattiaBatterica) {
            this.setState({malattiaBatterica: this.props.malattiaBatterica})
            this.controlloDati()
            let oggetto = this.createOggettoBE()
            this.props.setAgenteMIB(this.state.agente, oggetto)
        }
    }

    createOggettoBE() {
        let agente = JSON.parse(JSON.stringify(this.state.agente))
        let agenteBe = Utils.removeEmptyValueFromObject(agente)
        return Utils.removeFieldFromObject(agenteBe, "corretto")

    }

    controlloDati() {
        let agente = this.state.agente
        agente.corretto = []

        if (this.state.agente.tipizzazione === "1" && !this.state.agente.tipizzazioneTesto) agente.corretto[0] = "Campo \"Indicare gruppo/sierotipo\" mancante";
        if (this.state.agente.laboratorio === "2" && !this.state.agente.laboratorioTesto) agente.corretto[1] = "Campo \"Altro, specificare\" mancante";

        if (this.props.malattiaBatterica && this.props.malattiaBatterica === "malattiaBatterica1" && this.state.agente.corretto.length === 0){
            if(!this.state.agente.tipizzazione) agente.corretto[2] = "Campo \"è stata eseguita la tipizzazione? (solo se malattia invasiva da N.meningitidis, S. pneumoniae, H. influenzae)\" mancante";
            if(this.state.agente.tipizzazione === "1" && !this.state.agente.laboratorio) agente.corretto[3] = "Campo \"In quale laboratorio è stata effettuata?\" mancante";
        }

        this.setState({agente: agente})
    }

    riceviValore(field, event) {
        let agente = this.state.agente
        if (event.target.value === "true") {
            agente[field] = true;
        } else if (event.target.value === "false") {
            agente[field] = false;
        } else {
            agente[field] = event.target.value
            if (field === "tipizzazione" && event.target.value != 1) {
                agente["tipizzazioneTesto"] = ""
            }
            if (field === "laboratorio" && event.target.value != 2) {
                agente["laboratorioTesto"] = ""
            }
        }
        this.setState({agente: agente})

        this.controlloDati()
        let oggetto = this.createOggettoBE()
        this.props.setAgenteMIB(this.state.agente, oggetto)

    }

    controlloCheck(field, row) {
        let agente = this.state.agente
        let id = this.state.id
        let rowCheck = this.state.row
        let rowList = this.state.rowList

        if (this.state.id == "") {
            if (rowList) {
                id = field
                agente[rowList[row] + row] = false
                rowList[row] = field;

            } else {
                id = rowList[row]
                rowCheck = row
            }
        }

        if (field != id && rowCheck === row) {
            agente[id + row] = false
            rowList[row] = field;
        } else if (field != id && rowCheck != row && rowList != []) {
            agente[rowList[row] + row] = false
            rowList[row] = field;
        }

        this.setState({agente: agente, id: field, row: row, rowList: rowList})
    }

    boxCheckbox(id, text, radio, field, row) {
        let boxes = []
        const {t} = this.props;
        if (this.state.agente[id] && radio && this.state.rowList) {
            if (this.state.rowList[row] != field) {
                let rowList = this.state.rowList;
                rowList[row] = field
            }
        }
        boxes.push(
            <CheckBox
                id={id}
                parentClass={styles.azTableCellCheckbox}
                checked={this.state.agente[id]}
                text={t(text)}
                onChange={this.riceviValore}
                onClick={
                    radio ? () => this.controlloCheck(field, row) : ""
                }
                newCheckbox={true}
            >
            </CheckBox>
        )

        return boxes;
    }

    render() {

        const {t} = this.props;

        const sezione1 = (

            <div>
                <div>
                    <div className="col-lg-5" style={{marginTop: "1rem"}}>
                        <p style={{fontWeight: "bold", marginTop: "10px"}}>
                            {t("SchedaFlussoSpeciale.MIB.AgenteCausante.titolo")}
                        </p>
                    </div>

                    <div className="row">
                        <div className="col-lg-4">
                            {this.boxCheckbox("liquorAgente1", "SchedaFlussoSpeciale.MIB.AgenteCausante.1", false)}
                        </div>


                        <div className="col-lg-3">
                            <div className="row">
                                <div className="col-lg-4">
                                    {this.boxCheckbox("colturaAgente1", "SchedaFlussoSpeciale.MIB.AgenteCausante.2", true, "colturaAgente", 1)}
                                </div>
                                <div className="col-lg-8">
                                    {this.boxCheckbox("ricercaAgente1", "SchedaFlussoSpeciale.MIB.AgenteCausante.3", true, "ricercaAgente", 1)}
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-5">
                            {this.boxCheckbox("pcrAgente1", "SchedaFlussoSpeciale.MIB.AgenteCausante.4", true, "pcrAgente", 1)}
                        </div>

                    </div>
                </div>
            </div>
        );

        const sezione2 = (

            <div>
                <div className="col-lg-9" style={{marginTop: "1rem"}}>
                    <p style={{fontWeight: "bold", marginTop: "10px"}}>
                        {t("SchedaFlussoSpeciale.MIB.AgenteCausante.titolo2")}
                        {this.state.malattiaBatterica !== "" && this.props.malattiaBatterica === "malattiaBatterica1" ?
                            <span className={stylesWelcome.mandatoryColor}>*</span> : <span></span>}
                    </p>
                </div>
                <div className="row">

                    <div className="col-lg-3">
                        <div className="row">
                            <div className={"col-lg-3"}>
                                <RadioButton id={"tipizzazione1"}
                                             name={"tipizzazione"}
                                             label={t("SchedaFlussoSpeciale.MIB.AgenteCausante.5")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             value={"1"}
                                             checked={this.state.agente.tipizzazione === "1"}
                                >
                                </RadioButton>
                            </div>
                            <div className={"col-lg-9"}>
                                <Input
                                    id={"tipizzazioneTesto"}
                                    style={{height: "2rem", marginTop: "10px"}}
                                    onChange={this.riceviValore}
                                    field={"tipizzazioneTesto"}
                                    value={this.state.agente.tipizzazioneTesto}
                                    placeholder={t("SchedaFlussoSpeciale.MIB.AgenteCausante.6")}
                                    disabled={this.state.agente.tipizzazione !== "1"}
                                    required={this.state.agente.tipizzazione == "1"}
                                ></Input>
                            </div>
                        </div>
                    </div>

                    <div className={"col-lg-3"}>
                        <RadioButton id={"tipizzazione2"}
                                     name={"tipizzazione"}
                                     label={t("SchedaFlussoSpeciale.MIB.AgenteCausante.7")}
                                     style={{color: "black", fontSize: "16px"}}
                                     newRadio={true}
                                     onClick={this.riceviValore}
                                     value={"2"}
                                     checked={this.state.agente.tipizzazione === "2"}
                        >
                        </RadioButton>
                    </div>
                </div>
            </div>
        );
        const sezione3 = (
            <div>
                <div className="col-lg-9" style={{marginTop: "1rem"}}>
                    <p style={{marginTop: "10px"}}>
                        {t("SchedaFlussoSpeciale.MIB.AgenteCausante.titolo3")}
                        {this.state.malattiaBatterica !== "" && this.props.malattiaBatterica != "malattiaBatterica4" && this.state.agente.tipizzazione === "1" ?
                            <span className={stylesWelcome.mandatoryColor}>*</span> : <span></span>}</p>
                </div>

                <div className={"col-lg-6"}>
                    <RadioButton id={"laboratorio1"}
                                 name={"laboratorio"}
                                 label={t("SchedaFlussoSpeciale.MIB.AgenteCausante.8")}
                                 style={{color: "black", fontSize: "16px"}}
                                 newRadio={true}
                                 onClick={this.riceviValore}
                                 value={"1"}
                                 checked={this.state.agente.laboratorio === "1"}
                    >
                    </RadioButton>
                </div>

                <div className="col-lg-6">
                    <div className="row">
                        <div className={"col-lg-4"}>
                            <RadioButton id={"laboratorio2"}
                                         name={"laboratorio"}
                                         label={t("SchedaFlussoSpeciale.MIB.AgenteCausante.9")}
                                         style={{color: "black", fontSize: "16px"}}
                                         newRadio={true}
                                         onClick={this.riceviValore}
                                         value={"2"}
                                         checked={this.state.agente.laboratorio === "2"}
                            >
                            </RadioButton>
                        </div>
                        <div className={"col-lg-5"}>
                            <Input
                                id={"laboratorioTesto"}
                                style={{height: "2rem", marginTop: "10px"}}
                                onChange={this.riceviValore}
                                field={"laboratorioTesto"}
                                value={this.state.agente.laboratorioTesto}
                                placeholder={t("SchedaFlussoSpeciale.MIB.AgenteCausante.9")}
                                disabled={this.state.agente.laboratorio !== "2"}
                                required={this.state.agente.laboratorio == "2"}
                            ></Input>
                        </div>
                    </div>
                </div>


            </div>
        );

        return (
            <div className={"container"}>
                <fieldset disabled={!this.props.malattiaBatterica}>{sezione1}</fieldset>
                {sezione2}
                {sezione3}
            </div>

        )
    }

}

export default withTranslation('common')(AgenteCausanteMIB)
